module.exports = __webpack_public_path__ + "robotomono-regular-webfont-09e0ef66c9dee2fa2689f6e5f2437670.woff";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/fonts/roboto-mono/robotomono-regular-webfont.woff
// module id = 869
// module chunks = 86